import React from 'react'

export function ShoppingItem({ item, onToggle, onDelete }) {
  return (
    <div className={`flex items-center gap-3 py-2 border-b border-gray-100 last:border-0 ${item.is_checked ? 'opacity-50' : ''}`}>
      <button
        onClick={() => onToggle?.(item)}
        className={`w-5 h-5 rounded border-2 flex items-center justify-center transition-colors shrink-0 ${item.is_checked ? 'bg-emerald-500 border-emerald-500' : 'border-gray-300'}`}
      >
        {item.is_checked && (
          <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
          </svg>
        )}
      </button>
      <div className="flex-1 min-w-0">
        <p className={`text-sm ${item.is_checked ? 'line-through text-gray-400' : 'text-gray-800'}`}>
          {item.name}
        </p>
        {(item.quantity || item.unit) && (
          <p className="text-xs text-gray-400">
            {item.quantity} {item.unit}
          </p>
        )}
      </div>
      <button onClick={() => onDelete?.(item)} className="text-gray-300 hover:text-red-400 p-1">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  )
}
